<template>
    <span class="form-radio">
        <label>
            <input type="radio" @change="selectInput" :checked="checked" :name="name" :value="valueOn" v-bind="{...$attrs, ...ariaValidationAttributes}" :id="_id">
            <span aria-hidden="true" class="portuna-radio-button" :class="{checked}">
                <span class="portuna-radio-button-outer"></span>
                <span class="portuna-radio-button-inner"></span>
            </span>
            <span v-if="label" v-html="label"/>
            <span v-else class="hidden">Auswahl Option</span>
        </label>
    </span>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator';
    import {FormInput} from './FormInput.vue';

    @Component({
        name: 'FormInputRadio',
        inheritAttrs: false,
        emits: ['update:modelValue'],
    })
    export default class FormInputRadio extends FormInput
    {
        @Prop({
            type: [Boolean, Number, String],
        }) modelValue: boolean | number | string;

        @Prop({
            type: [Boolean, Number, String],
        }) valueOn: boolean | number | string;

        @Prop({
            type: String,
        }) label: string;

        get checked()
        {
            return this.modelValue === this.valueOn;
        }

        selectInput()
        {
            this.$emit('update:modelValue', this.valueOn);
        }

        updateValue()
        {
            if (!this.checked)
            {
                return Promise.resolve();
            }

            return this.validateValue(this.valueOn);
        }
    };
</script>